import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
// import Button from "../../components/ui/Button.js";
// import ContactForm from "../../components/ui/ContactForm.js";
import { MdOutlineLocalPhone, MdMailOutline, MdOutlineHome } from "react-icons/md";

const Sectors = () => {

  // const formRef = useRef(null);
  const history = useHistory();
  // const [activeTab, setActiveTab] = useState("Corporate Law");

  const handleClick = (field) => {
    history.push(field ? `/${field}` : "/");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const handleScrollToForm = () => {
  //   formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  // };


  return (
    <>
      <div className="overflow-hidden">


        <section className="bg-cover bg-no-repeat bg-right w-full h-auto" style={{ backgroundImage: `url('/assets/home/index-hero-section.webp')`, }}>
          <HeaderTransprent />
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="">
                <div className="flex items-center font-medium text-base text-white">
                  <MdOutlineHome size={24} className="mr-2 cursor-pointer" onClick={() => handleClick("")} />
                  <span className="mr-2 cursor-pointer" onClick={() => handleClick("expertise")}>/ Expertise</span>
                  <span>/ Ashish Ambasta</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="mx-auto px-4 xl:px-0 w-full 2xl:w-9/12 xl:w-11/12 h-full py-16">
          {/* Header */}
          <div className="bg-[#003366] flex flex-col md:flex-row items-center gap-6 md:p-4 p-6">
            <img src="/assets/home/ashish-ambasta.webp" alt="Ashish Ambasta" className="w-80 h-80 object-cover" />
            <div>
              <h1 className="md:text-4xl text-3xl font-semibold text-white">Ashish Ambasta</h1>
              <p className="text-lg text-white mt-2">Partner</p>
              <div className="flex flex-col mt-6 space-y-3 text-sm text-white">
                <div className="flex items-center gap-4">
                  {/* <div className="flex items-center justify-center w-7 h-7 bgcolor rounded-full"> */}
                  <MdOutlineLocalPhone className="w-6 h-6 text-white" />
                  {/* </div> */}
                  <span>+91 9819313559</span>
                </div>
                <div className="flex items-center gap-4">
                  {/* <div className="flex items-center justify-center w-7 h-7 bgcolor rounded-full"> */}
                  <MdMailOutline className="w-6 h-6 text-white" />
                  {/* </div> */}
                  <span>ashish@happyplus.in</span>
                </div>
              </div>
            </div>
          </div>


          {/* Intro */}
          <h1 className="textblack mt-8 text-base leading-relaxed">
            Ashish is a seasoned legal professional based in Mumbai, serving as a partner at a reputed law firm.
            With over a decade of experience, he supports clients across litigation, alternative dispute resolution
            (ADR), and strategic employment law advisory. His practice is rooted in delivering practical, business-aligned
            legal solutions that help clients stay compliant, manage risk, and resolve disputes effectively.
          </h1>

          <hr className="my-8 border-t-2 border-[#CB9B2D]" />

          {/* Main Grid */}
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Left: Expertise */}
            <div className="w-full space-y-6 py-8">
              <div>
                <h2 className="text-lg font-semibold textblack mb-3">EXPERTISE</h2>
                <p className="text-sm textblack">Ashish is a seasoned legal professional based in Mumbai, serving as a partner at a reputed law firm. With over a decade of experience, he supports clients across litigation, alternative dispute resolution (ADR), and strategic employment law advisory. His practice is rooted in delivering practical, business-aligned legal solutions that help clients stay compliant, manage risks, and resolve disputes effectively.</p>
              </div>

              <div className="pl-5">
                <h3 className="font-semibold textblack">• Organisational Policies</h3>
                <p className="text-sm textblack mt-1 pl-4">
                  Designing and implementing HR policies, employment handbooks, POSH frameworks, codes of conduct,
                  and workplace governance mechanisms that align with Indian laws and global best practices.
                </p>
              </div>

              <div className="pl-5">
                <h3 className="font-semibold textblack">• Labour & Industrial Disputes</h3>
                <p className="text-sm textblack mt-1 pl-4">
                  Representing companies in industrial disputes, disciplinary inquiries, employee terminations,
                  and misconduct investigations. He has been known for his astute arguments and practical counsel
                  before courts and tribunals.
                </p>
              </div>

              <div className="pl-5">
                <h3 className="font-semibold textblack">• Labour Law Compliance</h3>
                <p className="text-sm textblack mt-1 pl-4">
                  Assisting clients with pan-India employment law support including reviewing the new labour codes,
                  drafting employment contracts, advising on employee classifications, and internal HR reviews.
                </p>
              </div>

              <div className="">
                <p className="text-sm textblack">Ashish works closely with clients in the manufacturing, services, and banking sectors, offering industry-specific guidance that factors in operational realities. Whether it’s helping a factory update its shift policies or guiding a financial institution through employee exits during restructuring, his advice is always rooted in the law and tailored to client needs.</p>
              </div>

              <div className="">
                <p className="text-sm textblack">In addition to advisory, Ashish regularly appears before Labour Courts, Industrial Tribunals, High Courts, and other quasi-judicial forums. He also supports clients in arbitration and mediation processes, helping them resolve disputes efficiently without prolonged litigation.</p>
              </div>

              <div className="">
                <p className="text-sm textblack">Ashish is appreciated by his clients for his responsiveness, clarity of thought, and ability to translate complex legal concepts into actionable business steps. His commitment to client success and preventive legal planning makes him a trusted advisor for HR leaders, in-house counsel, and business owners alike.</p>
              </div>
            </div>

            {/* Right: Practice Areas */}
            {/* <aside className="space-y-6 lg:w-1/3 bg-[#F7F8FA] p-6 h-full">
              <div>
                <h2 className="text-lg font-semibold textblack mb-2">PRACTICE AREAS</h2>
                <ul className="list-disc list-inside text-sm textblack space-y-1">
                  <li>Antitrust And Competition Law</li>
                  <li>Capital Markets: India & Intl.</li>
                  <li>Family Business</li>
                  <li>Employment Law</li>
                  <li>Corporate Law</li>
                </ul>
              </div>
              <hr className="my-12 border-t-2 border-[#CB9B2D]" />
              <div>
                <h2 className="text-lg font-semibold textblack mb-2">SECTORS</h2>
                <ul className="list-disc list-inside text-sm textblack space-y-1">
                  <li>Antitrust And Competition Law</li>
                  <li>Capital Markets: India & Intl.</li>
                  <li>Family Business</li>
                  <li>Corporate Law</li>
                </ul>
              </div>
            </aside> */}
          </div>
        </div>


        {/* <section ref={formRef} className="bg-cover bg-no-repeat md:py-16 py-8 bg-[#F7F8FA]">
          <div className="flex flex-col justify-start w-full h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 w-full">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/2 flex flex-col justify-center md:mb-0 pr-0 md:pr-10 md:pt-0 pt-4">
                  <div className="flex items-center justify-center w-full">
                    <img src="/assets/home/contact-us.webp" alt="Lead with Clarity" className="z-0" />
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section> */}

        <Footer />
      </div>
    </>
  );
};


export default Sectors;
